module.exports = __webpack_public_path__ + "img/box2.bd4b7832.png";